module.exports = __webpack_public_path__ + "img/postgresql.99856577.png";